import Layout from "../components/layout/Layout"
import Brand1 from "../components/sections/Brand1"
import ServiceDetails6 from "../components/sections/ServiceDetails6"
import Imgsec3 from "../components/sections/imgsec3"
export default function ServicesDetails1() {
	return (
		<>
			<Layout
				headerStyle={1}
				footerStyle={1}
				// breadcrumbTitle="Services details"
			>
				<ServiceDetails6 />
				{/* <Brand1 /> */}
				<Imgsec3 />
			</Layout>
		</>
	)
}
